import { MdPerson } from 'react-icons/md';
import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSavedGroupTags } from 'services/CommonService';
import { generateDropdownOptionsFromTagManagerValue } from 'shared/helpers/common';
import CircleIcon from 'components/CircleIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import PassportItem from './PassportItem';

export default function PassportsTab({ booking }) {
  const { textConfig = {} } = useSelector((state) => state.ui);
  const [passengers, setPassengers] = useState(booking?.passengers || []);
  const [formDropdownConfig, setFormDropdownConfig] = useState({
    countryOfResidence: [],
    nationality: [],
  });
  const { whiteLabelSettings: { primaryColour } = {} } = useWhiteLabelSettings();

  const loadData = useCallback(async () => {
    const APIS_TAG = 'APIS';
    try {
      const { data: { APIS: apisData = [] } = {} } = await getSavedGroupTags([
        APIS_TAG,
      ]);
      setFormDropdownConfig(
        generateDropdownOptionsFromTagManagerValue(apisData),
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const updatePassportList = (id, updatedData = {}) => {
    const updatedPassportList = passengers.map((passport) => {
      if (passport.id === id) {
        const updatedPassenger = updatedData.find((data) => data.id === id);
        return updatedPassenger ? { ...passport, ...updatedPassenger } : passport;
      }
      return passport;
    });

    setPassengers(updatedPassportList);
  };

  const onPassportUpdate = (id, updatedData) => {
    updatePassportList(id, updatedData);
  };

  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <MdPerson style={{ fill: primaryColour }} />
        </CircleIcon>
        <SectionLabel label="Passports" className="ml-[10px] mt-1" />
      </div>
      {textConfig?.passportsText && (
        <div className="text-gray-600 mt-7">
          {textConfig.passportsText}
        </div>
      )}
      <div className="mt-[20px] lg:mt-[20px] flex flex-wrap">
        {passengers.map((passenger, index) => (
          <PassportItem
            key={passenger?.id || index}
            data={passenger}
            onPassportUpdate={onPassportUpdate}
            formDropdownConfig={formDropdownConfig}
            bookingRefOrId={booking.reference || booking.id}
          />
        ))}
      </div>
    </>
  );
}
